<template>
  <div v-if="user && isUserPro(user) && user.sca_status === 'required'" class="block block-warning">
    <img src="/static/images/icons/warning.svg" alt="Attention" class="icon" />
    <div>
      <p>Pour des raisons de réglementation bancaire européenne (directive <a href="https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=celex%3A32015L2366" target="eu-legal">PSD2</a>),
        il est désormais nécessaire de vous authentifier sur notre plateforme de paiement.</p>
      <p>
        Pour ce faire, vous allez être redirigé sur une page de notre partenaire Mangopay qui vous proposera
        plusieurs options pour vous authentifier, par exemple un code reçu par SMS ou par email.</p>
      <p>Cliquez ci-dessous pour lancer la procédure&nbsp;:</p>
      <ui-button w="300px" @click="startUserSCA()">Commencer la procédure</ui-button>
    </div>
  </div>
</template>
<script>
import { registrationHelpers } from '@/main'

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    if (this.$route.query.controlStatus || this.$route.query.actionStatus) {
      if (this.$route.query.sca_bank_type && this.$route.query.controlStatus === 'VALIDATED') {
        const { controlStatus, actionStatus, sca_bank_id, sca_bank_type, ...query } = this.$route.query
        this.$router.replace({ query })
        this.doSaveSCA(sca_bank_id, sca_bank_type)
      } else {
        registrationHelpers.fetchDataUser(this, () => {
          const { controlStatus, actionStatus, ...query } = this.$route.query
          this.$router.replace({ query })
        })
      }
    }
  },
  methods: {
    isUserPro(user) {
      return user && (registrationHelpers.userTypes.is(user, 'proprio') || registrationHelpers.userTypes.is(user, 'agent'))
    },
    doSaveSCA(owner_type, owner_id) {
      return this.$http.post(`/api/bank_accounts?ownerType=${owner_type}&ownerID=${owner_id}&sca=true`, null)
        .then(res => {
          if (res.data.sca_redirect_url && res.data.sca_type === 'bank') {
            this.startBankSCA(res.data.sca_redirect_url)
          }
          return res
        })
    },
    startBankSCA(sca_redirect_url) {
      const returnUrl = encodeURIComponent(window.location.href)
      window.location.href = `${sca_redirect_url}&returnUrl=${returnUrl}`
    },
    startUserSCA() {
      return this.$http.post('/api/mangopay/enroll-sca', null)
        .then(res => {
          if (res.data && res.data.sca_redirect_url) {
            const url = encodeURIComponent(window.location.href)
            window.location.href = `${res.data.sca_redirect_url}&returnUrl=${url}`
          }
        })
    },
  },
  components: {
    UiButton: require('@/ui/Button').default,
  },
}
</script>
